import { createReducer } from 'redux-act';
import { IDictionary } from "../../types";
import { fetchChecksumsJSONSuccess } from "modules/actions";

export interface IChecksum extends IDictionary<string> {
}

const defaultState: IChecksum = {};

export const checksums = createReducer<typeof defaultState>({}, defaultState)
	.on(fetchChecksumsJSONSuccess, (_state, payload) => payload)
;